import { Location } from '@reach/router';
import { useIntl } from 'gatsby-plugin-intl';
import React from 'react';
import urlJoin from 'url-join';

import { APP_CREATOR, APP_NAME } from '@constants/application';
import { BASE_APPLICATION_HOST } from '@constants/env';

import OpenGraphTags from '../OpenGraphTags';

type PropTypes = {
  title?: string;
  description?: string | null;
  imageURL?: string;
  keywords?: string;
};

const HeaderTags = ({ title, description, imageURL, keywords }: PropTypes): JSX.Element => {
  const { locale } = useIntl();

  const { formatMessage } = useIntl();

  const mainTitle = formatMessage({ id: 'page-title' });
  const titleString = title ? `${mainTitle} | ${title}` : mainTitle;

  return (
    <Location>
      {({ location }): JSX.Element => (
        <OpenGraphTags
          creator={APP_CREATOR}
          language={locale}
          siteName={APP_NAME}
          title={titleString}
          url={urlJoin(BASE_APPLICATION_HOST, location.pathname)}
          description={description}
          imageURL={imageURL}
          keywords={keywords}
        />
      )}
    </Location>
  );
};

export default HeaderTags;
